const allAlerts = 1000000;
export const alertRoutes = {
  alert: '/alert',
  getAlert: (id: number) => `/alert/${id}`,
  getAlerts: `/alert/1/${allAlerts}`,
} as const;
